<template>
  <div class="swiper" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
    <div class="inner">
      <!-- 插槽：轮播图每一项 -->
      <slot></slot>
      <!-- 轮播图指示点 
        hasDot：是否显示 
        itemLen：轮播图长度（几个点 由于用的是插槽所以用this.$slots.default.length获取长度）
        currentIndex：当前轮播滑块  
        dotBgColor：当前指示点颜色
        @dotClick：点击指示点
      -->
      <SwiperDot 
        :hasDot="hasDot" 
        :itemLen="this.$slots.default.length" 
        :currentIndex="currentIndex"
        :dotBgColor="dotBgColor" 
        @dotClick="dotClick"></SwiperDot>
    </div>
  </div>
</template>
<script>
import SwiperDot from './dot.vue'
export default {
  components: {
    SwiperDot
  },
  props: {
    // 是否自动切换
    autoplay: {
      type: Boolean,
      default: true
    },
    //自动切换时间间隔
    duration: {
      type: Number,
      default: 3000
    },
    //当前所在滑块的 index
    initial: {
      type: Number,
      default: 0
    },
    //是否显示面板指示点
    hasDot: {
      type: Boolean,
      default: true
    },
    //当前滑块指示点颜色
    dotBgColor: String,
  },
  data() {
    return {
      timer: null,//存放定时器的变量 用于使用完后清楚
      currentIndex: this.initial,//当前轮播滑块
      direction: "next"//轮播方向 点击指示点或点击方向时使用
    }
  },
  mounted() {
    this.autoplays()//开启轮播
  },
  destroyed() {
    this.clearIntervalFn()//清楚定时器结束轮播
  },
  methods: {
    // 开启轮播
    autoplays() {
      if (this.autoplay) {
        this.direction = "next"
        this.timer = setInterval(() => {
          this.setIndex('next')//切换轮播滑块
        }, this.duration);
      }
    },
    // 切换轮播滑块
    setIndex(dir) {
      switch (dir) {
        case 'next'://下一个
          this.currentIndex += 1
          if (this.currentIndex === this.$slots.default.length) {
            this.currentIndex = 0
          }
          break;
        case 'prev'://上一个
          this.currentIndex -= 1
          if (this.currentIndex === -1) {
            this.currentIndex = this.$slots.default.length - 1
          }
          break;
      }
    },
    // 点击指示点 index点击的下标 direction方向（点击的指示点是当前滑块指示点的前面还是后面）
    dotClick(index, direction) {
      this.direction = direction
      this.currentIndex = index
    },
    // 鼠标移入 停止轮播
    mouseEnter() {
      this.clearIntervalFn()
    },
    // 鼠标移出 开启轮播
    mouseLeave() {
      this.autoplays()
    },
    // 清楚定时器方法
    clearIntervalFn() {
      clearInterval(this.timer)
      this.timer = null
    }
  },

}
</script>
<style lang="scss" scoped>
.swiper {
  width: 516px;
  height: 307px;

  .inner {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
}
</style>  